<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">Default shares - {{brickName}} - {{buLineName}}</span>
    <a class="pull-right" href="javascript:;" (click)="back()"><i class="fa fa-times"></i> Close</a>
  </div>
  <div class="panel-body padding-sm-hr">
    <p class="text-muted">
      How the brick's sales are split between the {{names.holders | lowercase}} holding it, period by period. Saving a period sets the shares
      for those days only (no <i>To</i> = from that day on); the days before and after keep theirs. A distributor brick's own split
      (Distributors &gt; Distributor Bricks &gt; Setup) and the product splits below come first.
    </p>
    <div class="margin-bottom-10" *ngIf="!editing">
      <a href="javascript:;" (click)="newPeriod()"><i class="fa fa-plus-circle"></i> New period</a>
    </div>

    <div class="well well-sm" *ngIf="editing">
      <div class="row padding-xs-vr">
        <div class="col-sm-3">
          <label class="control-label">From <span class="text-danger">*</span></label>
          <input class="form-control" type="date" name="shStart" [(ngModel)]="editStart" (change)="fillRows()">
        </div>
        <div class="col-sm-3">
          <label class="control-label">To (optional)</label>
          <input class="form-control" type="date" name="shEnd" [(ngModel)]="editEnd" [min]="editStart">
        </div>
        <div class="col-sm-4 margin-top-20" *ngIf="editRows.length > 1">
          <a href="javascript:;" (click)="equalShares()"><i class="fa fa-balance-scale"></i> Equal shares</a>
        </div>
      </div>
      <table class="table table-condensed" *ngIf="editRows.length">
        <thead><tr><th>{{names.holder}}</th><th class="text-right" style="width:160px">Share %</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of editRows; let i = index">
            <td>{{r.businessUnitName}}</td>
            <td><input type="number" class="form-control input-sm text-right" [(ngModel)]="r.percent" name="shPct{{i}}" min="0" max="100" step="0.01"></td>
          </tr>
          <tr><td><b>Total</b></td><td class="text-right" [class.text-danger]="editRows.length > 1 && (editTotal < 99.95 || editTotal > 100)"><b>{{editTotal}}</b></td></tr>
        </tbody>
      </table>
      <div class="text-muted" *ngIf="!editRows.length && !editError">Choose the start date: the {{names.holders | lowercase}} holding the brick that day are listed.</div>
      <div class="text-danger" *ngIf="editError">{{editError}}</div>
      <div class="margin-top-10">
        <button type="button" class="btn btn-cancel" (click)="editing = false">Cancel</button>&nbsp;
        <button type="button" class="btn btn-save" [disabled]="saving" (click)="saveShares()">Save shares</button>
      </div>
    </div>

    <div class="text-center" *ngIf="loadingPeriods"><i class="fa fa-spinner fa-spin"></i></div>
    <table class="table table-condensed" *ngIf="!loadingPeriods">
      <thead><tr><th style="width:110px">From</th><th style="width:110px">To</th><th>Shares</th><th style="width:50px"></th></tr></thead>
      <tbody>
        <tr *ngFor="let p of periods" [class.info]="isAsOf(p)">
          <td>{{p.start | date:'dd/MM/yyyy'}}</td><td>{{p.end ? (p.end | date:'dd/MM/yyyy') : 'open'}}</td>
          <td>{{sharesText(p)}}</td>
          <td><a href="javascript:;" title="Edit this period" (click)="editPeriod(p)"><i class="fa fa-edit"></i></a></td>
        </tr>
        <tr *ngIf="!periods.length"><td colspan="4" class="text-muted">No {{names.holder | lowercase}} of this {{names.line | lowercase}} holds the brick.</td></tr>
      </tbody>
    </table>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">Product splits - {{brickName}} - {{buLineName}}</span>
    <a class="pull-right" href="javascript:;" *ngIf="!productEditing" (click)="productSplit = null; productEditing = true"><i class="fa fa-plus-circle"></i> Add</a>
  </div>
  <div class="panel-body padding-sm-hr">
    <p class="text-muted">A brand or item shared differently between these {{names.holders | lowercase}}, for sales from every distributor brick.
      A distributor brick's own {{names.holder | lowercase}} split (Distributors &gt; Distributor Bricks &gt; Setup) comes first.</p>
    <crm-territory-split-editor *ngIf="productEditing" [fixedBrickId]="brickId" [fixedLineId]="buLineId" [requireProduct]="true"
      [products]="products" [split]="productSplit" (saved)="productSplitSaved()" (cancelled)="productEditing = false"></crm-territory-split-editor>
    <table class="table table-condensed">
      <thead><tr><th>Product</th><th style="width:110px">From</th><th style="width:110px">To</th><th>Shares</th><th style="width:70px"></th></tr></thead>
      <tbody>
        <tr *ngFor="let s of productSplits">
          <td>{{s.product?.name}}</td>
          <td>{{s.start | date:'dd/MM/yyyy'}}</td><td>{{s.end ? (s.end | date:'dd/MM/yyyy') : 'open'}}</td>
          <td>{{splitText(s)}}</td>
          <td>
            <a href="javascript:;" title="Edit" (click)="editProductSplit(s)"><i class="fa fa-edit"></i></a>&nbsp;
            <a href="javascript:;" title="Delete" (click)="deleteProductSplit(s)"><i class="fa fa-trash-o"></i></a>
          </td>
        </tr>
        <tr *ngIf="!productSplits.length"><td colspan="5" class="text-muted">None: every product uses the default shares.</td></tr>
      </tbody>
    </table>
  </div>
</div>
